








import Vue from 'vue';
import isGranted from '../../auth/isGranted';
import { AccountSubscriber, UserSubscriptionsTableElement } from '../../types';
import UserSubscriptionsTable from './UserSubscriptionsTable.vue';

export default Vue.extend({
  props: {
    userId: {
      type: String,
      required: true,
    },
  },
  methods: {
    add(subscribers: AccountSubscriber[]): void {
      (this.$refs.userSubscriptionsTable as UserSubscriptionsTableElement).addMultiple(subscribers);
    },
    isGranted,
  },
  components: {
    UserSubscriptionsTable,
  },
});
